import { createContext, useContext, useEffect, useMemo, useState } from "react";
//import { useQuery } from "@tanstack/react-query";
//import { getCustomerOptions } from "services/data.internal.service";
import { useAuth } from "auth/authProvider";

const CustomerContext = createContext(null);

export function useCustomerValue() {
  return useContext(CustomerContext);
}

export function CustomerProvider({ children }) {
  const [customerOpt, setCustomerOpt] = useState([]);
  const [customerCode, setCustomerCode] = useState(null);
  const{customers,customer}=useAuth()
  useEffect(()=>{
    if(customers === null) return
    const data = customers.map(x=>x.customerCode)
    let data_ = [] 
    data.forEach(x=>{
      if(!data_.includes(x)){
        data_.push(x)
      }
    })
    setCustomerOpt(data_)
  },[customers])
  useEffect(()=>{
    setCustomerCode(customer)
    console.log(`customer ${customer} updated!`)
  },[customer])
  // useQuery({
  //   queryKey: ["customer-options"],
  //   queryFn: () => getCustomerOptions(),
  //   refetchOnWindowFocus: false,
  //   onSuccess: (data) => {
  //     setCustomerOpt(data.data.map((x) => x));
  //     if (data.data.length > 0) {
  //       setCustomerCode(data.data[0]);
  //     }
  //   },
  // });
  const providerValue = useMemo(() => {
    return {
      customerCode,
      setCustomerCode,
      customerOpt,
    };
  }, [customerCode, setCustomerCode, customerOpt]);
  return <CustomerContext.Provider value={providerValue}>{children}</CustomerContext.Provider>;
}
